module.exports = __webpack_public_path__ + "static/img/15.ec492fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/15.png
// module id = z/Ai
// module chunks = 0